// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3m9nq","inputWrap":"styles_inputWrap__33KTh","input":"styles_input__2hWe3"};